@let tableConfig = tableConfigSg();
@let hasVariables = hasVariablesSg();
@let hasOverflowActions = widgetStore.hasOverflowActionsSg();
@let overflowActions = widgetStore.overflowActionsSg();
@let refId = widgetStore.refIdSg();
@let hasAppliedVariableValues = hasAppliedVariableValuesSg();

@if (tableConfig) {
  <atn-ds-table [config]="tableConfig">
    <!-- Display overflow button in header when actions are available -->
    <ng-container customTools>
      @if (hasVariables) {
        <i
          class="atn-icon atn-funnel atn-blue"
          [class.atn-mosaic-table__icon-with-info]="hasAppliedVariableValues"
          (click)="openVariablesSlideoutHandler()"
        ></i>
      }
      @if (hasOverflowActions) {
        <atn-widget-overflow-menu
          [actions]="overflowActions"
          [refId]="refId"
        />
      }
    </ng-container>
  </atn-ds-table>
} @else {
  <div class="atn-mosaic-table__empty-state-container">
    <div class="atn-mosaic-table__empty-state-content">
      <atn-ds-empty-state
        type="no-data"
        title="No content to display"
      />
    </div>
  </div>
}
